export default [
  {
    id: "AT",
    full_name_locale: "Austria",
    full_name_english: "Austria",
    available_regions: null,
  },
  {
    id: "BE",
    full_name_locale: "Belgium",
    full_name_english: "Belgium",
    available_regions: null,
  },
  {
    id: "CA",
    full_name_locale: "Canada",
    full_name_english: "Canada",
    available_regions: [
      {
        code: "AB",
        name: "Alberta",
      },
      {
        code: "BC",
        name: "British Columbia",
      },
      {
        code: "MB",
        name: "Manitoba",
      },
      {
        code: "NB",
        name: "New Brunswick",
      },
      {
        code: "NL",
        name: "Newfoundland and Labrador",
      },
      {
        code: "NT",
        name: "Northwest Territories",
      },
      {
        code: "NS",
        name: "Nova Scotia",
      },
      {
        code: "NU",
        name: "Nunavut",
      },
      {
        code: "ON",
        name: "Ontario",
      },
      {
        code: "PE",
        name: "Prince Edward Island",
      },
      {
        code: "QC",
        name: "Quebec",
      },
      {
        code: "SK",
        name: "Saskatchewan",
      },
      {
        code: "YT",
        name: "Yukon Territory",
      },
    ],
  },
  {
    id: "CH",
    full_name_locale: "Switzerland",
    full_name_english: "Switzerland",
    available_regions: null,
  },
  {
    id: "CZ",
    full_name_locale: "Czech Republic",
    full_name_english: "Czech Republic",
    available_regions: null,
  },
  {
    id: "DE",
    full_name_locale: "Germany",
    full_name_english: "Germany",
    available_regions: null,
  },
  {
    id: "DK",
    full_name_locale: "Denmark",
    full_name_english: "Denmark",
    available_regions: null,
  },
  {
    id: "ES",
    full_name_locale: "Spain",
    full_name_english: "Spain",
    available_regions: null,
  },
  {
    id: "FI",
    full_name_locale: "Finland",
    full_name_english: "Finland",
    available_regions: null,
  },
  {
    id: "FR",
    full_name_locale: "France",
    full_name_english: "France",
    available_regions: null,
  },
  {
    id: "GB",
    full_name_locale: "United Kingdom",
    full_name_english: "United Kingdom",
    available_regions: null,
  },
  {
    id: "IE",
    full_name_locale: "Ireland",
    full_name_english: "Ireland",
    available_regions: [
      {
        code: "CE",
        name: "Clare",
      },
      {
        code: "CN",
        name: "Cavan",
      },
      {
        code: "CO",
        name: "Cork",
      },
      {
        code: "CW",
        name: "Carlow",
      },
      {
        code: "D",
        name: "Dublin",
      },
      {
        code: "DL",
        name: "Donegal",
      },
      {
        code: "G",
        name: "Galway",
      },
      {
        code: "KE",
        name: "Kildare",
      },
      {
        code: "KK",
        name: "Kilkenny",
      },
      {
        code: "KY",
        name: "Kerry",
      },
      {
        code: "LD",
        name: "Longford",
      },
      {
        code: "LH",
        name: "Louth",
      },
      {
        code: "LK",
        name: "Limerick",
      },
      {
        code: "LM",
        name: "Leitrim",
      },
      {
        code: "LS",
        name: "Laois",
      },
      {
        code: "MH",
        name: "Meath",
      },
      {
        code: "MN",
        name: "Monaghan",
      },
      {
        code: "MO",
        name: "Mayo",
      },
      {
        code: "OY",
        name: "Offaly",
      },
      {
        code: "RN",
        name: "Roscommon",
      },
      {
        code: "Sligo",
        name: "SO",
      },
      {
        code: "TA",
        name: "Tipperary",
      },
      {
        code: "WD",
        name: "Waterford",
      },
      {
        code: "WH",
        name: "Westmeath",
      },
      {
        code: "WW",
        name: "Wicklow",
      },
      {
        code: "WX",
        name: "Wexford",
      },
    ],
  },
  {
    id: "IT",
    full_name_locale: "Italy",
    full_name_english: "Italy",
    available_regions: [
      {
        code: "AG",
        name: "Agrigento",
      },
      {
        code: "AL",
        name: "Alessandria",
      },
      {
        code: "AN",
        name: "Ancona",
      },
      {
        code: "AO",
        name: "Aosta",
      },
      {
        code: "AR",
        name: "Arezzo",
      },
      {
        code: "AP",
        name: "Ascoli-Piceno",
      },
      {
        code: "AT",
        name: "Asti",
      },
      {
        code: "AV",
        name: "Avellino",
      },
      {
        code: "BA",
        name: "Bari",
      },
      {
        code: "BT",
        name: "Barletta-Andria-Trani",
      },
      {
        code: "BL",
        name: "Belluno",
      },
      {
        code: "BN",
        name: "Benevento",
      },
      {
        code: "BG",
        name: "Bergamo",
      },
      {
        code: "BI",
        name: "Biella",
      },
      {
        code: "BO",
        name: "Bologna",
      },
      {
        code: "BZ",
        name: "Bolzano",
      },
      {
        code: "BS",
        name: "Brescia",
      },
      {
        code: "BR",
        name: "Brindisi",
      },
      {
        code: "CA",
        name: "Cagliari",
      },
      {
        code: "CL",
        name: "Caltanissetta",
      },
      {
        code: "CB",
        name: "Campobasso",
      },
      {
        code: "CI",
        name: "Carbonia Iglesias",
      },
      {
        code: "CE",
        name: "Caserta",
      },
      {
        code: "CT",
        name: "Catania",
      },
      {
        code: "CZ",
        name: "Catanzaro",
      },
      {
        code: "CH",
        name: "Chieti",
      },
      {
        code: "CO",
        name: "Como",
      },
      {
        code: "CS",
        name: "Cosenza",
      },
      {
        code: "CR",
        name: "Cremona",
      },
      {
        code: "KR",
        name: "Crotone",
      },
      {
        code: "CN",
        name: "Cuneo",
      },
      {
        code: "EN",
        name: "Enna",
      },
      {
        code: "FM",
        name: "Fermo",
      },
      {
        code: "FE",
        name: "Ferrara",
      },
      {
        code: "FI",
        name: "Firenze",
      },
      {
        code: "FG",
        name: "Foggia",
      },
      {
        code: "FC",
        name: "Forli-Cesena",
      },
      {
        code: "FR",
        name: "Frosinone",
      },
      {
        code: "GE",
        name: "Genova",
      },
      {
        code: "GO",
        name: "Gorizia",
      },
      {
        code: "GR",
        name: "Grosseto",
      },
      {
        code: "IM",
        name: "Imperia",
      },
      {
        code: "IS",
        name: "Isernia",
      },
      {
        code: "AQ",
        name: "L'Aquila",
      },
      {
        code: "SP",
        name: "La-Spezia",
      },
      {
        code: "LT",
        name: "Latina",
      },
      {
        code: "LE",
        name: "Lecce",
      },
      {
        code: "LC",
        name: "Lecco",
      },
      {
        code: "LI",
        name: "Livorno",
      },
      {
        code: "LO",
        name: "Lodi",
      },
      {
        code: "LU",
        name: "Lucca",
      },
      {
        code: "MC",
        name: "Macerata",
      },
      {
        code: "MN",
        name: "Mantova",
      },
      {
        code: "MS",
        name: "Massa-Carrara",
      },
      {
        code: "MT",
        name: "Matera",
      },
      {
        code: "VS",
        name: "Medio Campidano",
      },
      {
        code: "ME",
        name: "Messina",
      },
      {
        code: "MI",
        name: "Milano",
      },
      {
        code: "MO",
        name: "Modena",
      },
      {
        code: "MB",
        name: "Monza-Brianza",
      },
      {
        code: "NA",
        name: "Napoli",
      },
      {
        code: "NO",
        name: "Novara",
      },
      {
        code: "NU",
        name: "Nuoro",
      },
      {
        code: "OG",
        name: "Ogliastra",
      },
      {
        code: "OT",
        name: "Olbia Tempio",
      },
      {
        code: "OR",
        name: "Oristano",
      },
      {
        code: "PD",
        name: "Padova",
      },
      {
        code: "PA",
        name: "Palermo",
      },
      {
        code: "PR",
        name: "Parma",
      },
      {
        code: "PV",
        name: "Pavia",
      },
      {
        code: "PG",
        name: "Perugia",
      },
      {
        code: "PU",
        name: "Pesaro-Urbino",
      },
      {
        code: "PE",
        name: "Pescara",
      },
      {
        code: "PC",
        name: "Piacenza",
      },
      {
        code: "PI",
        name: "Pisa",
      },
      {
        code: "PT",
        name: "Pistoia",
      },
      {
        code: "PN",
        name: "Pordenone",
      },
      {
        code: "PZ",
        name: "Potenza",
      },
      {
        code: "PO",
        name: "Prato",
      },
      {
        code: "RG",
        name: "Ragusa",
      },
      {
        code: "RA",
        name: "Ravenna",
      },
      {
        code: "RC",
        name: "Reggio-Calabria",
      },
      {
        code: "RE",
        name: "Reggio-Emilia",
      },
      {
        code: "RI",
        name: "Rieti",
      },
      {
        code: "RN",
        name: "Rimini",
      },
      {
        code: "RM",
        name: "Roma",
      },
      {
        code: "RO",
        name: "Rovigo",
      },
      {
        code: "SA",
        name: "Salerno",
      },
      {
        code: "SS",
        name: "Sassari",
      },
      {
        code: "SV",
        name: "Savona",
      },
      {
        code: "SI",
        name: "Siena",
      },
      {
        code: "SR",
        name: "Siracusa",
      },
      {
        code: "SO",
        name: "Sondrio",
      },
      {
        code: "TA",
        name: "Taranto",
      },
      {
        code: "TE",
        name: "Teramo",
      },
      {
        code: "TR",
        name: "Terni",
      },
      {
        code: "TO",
        name: "Torino",
      },
      {
        code: "TP",
        name: "Trapani",
      },
      {
        code: "TN",
        name: "Trento",
      },
      {
        code: "TV",
        name: "Treviso",
      },
      {
        code: "TS",
        name: "Trieste",
      },
      {
        code: "UD",
        name: "Udine",
      },
      {
        code: "VA",
        name: "Varese",
      },
      {
        code: "VE",
        name: "Venezia",
      },
      {
        code: "VB",
        name: "Verbania",
      },
      {
        code: "VC",
        name: "Vercelli",
      },
      {
        code: "VR",
        name: "Verona",
      },
      {
        code: "VV",
        name: "Vibo-Valentia",
      },
      {
        code: "VI",
        name: "Vicenza",
      },
      {
        code: "VT",
        name: "Viterbo",
      },
    ],
  },
  {
    id: "NL",
    full_name_locale: "Netherlands",
    full_name_english: "Netherlands",
    available_regions: null,
  },
  {
    id: "NO",
    full_name_locale: "Norway",
    full_name_english: "Norway",
    available_regions: null,
  },
  {
    id: "PL",
    full_name_locale: "Poland",
    full_name_english: "Poland",
    available_regions: null,
  },
  {
    id: "SE",
    full_name_locale: "Sweden",
    full_name_english: "Sweden",
    available_regions: null,
  },
  {
    id: "US",
    full_name_locale: "United States",
    full_name_english: "United States",
    available_regions: [
      {
        code: "AL",
        name: "Alabama",
      },
      {
        code: "AK",
        name: "Alaska",
      },
      {
        code: "AS",
        name: "American Samoa",
      },
      {
        code: "AZ",
        name: "Arizona",
      },
      {
        code: "AR",
        name: "Arkansas",
      },
      {
        code: "AE",
        name: "Armed Forces Africa",
      },
      {
        code: "AA",
        name: "Armed Forces Americas",
      },
      {
        code: "AE",
        name: "Armed Forces Canada",
      },
      {
        code: "AE",
        name: "Armed Forces Europe",
      },
      {
        code: "AE",
        name: "Armed Forces Middle East",
      },
      {
        code: "AP",
        name: "Armed Forces Pacific",
      },
      {
        code: "CA",
        name: "California",
      },
      {
        code: "CO",
        name: "Colorado",
      },
      {
        code: "CT",
        name: "Connecticut",
      },
      {
        code: "DE",
        name: "Delaware",
      },
      {
        code: "DC",
        name: "District of Columbia",
      },
      {
        code: "FM",
        name: "Federated States Of Micronesia",
      },
      {
        code: "FL",
        name: "Florida",
      },
      {
        code: "GA",
        name: "Georgia",
      },
      {
        code: "GU",
        name: "Guam",
      },
      {
        code: "HI",
        name: "Hawaii",
      },
      {
        code: "ID",
        name: "Idaho",
      },
      {
        code: "IL",
        name: "Illinois",
      },
      {
        code: "IN",
        name: "Indiana",
      },
      {
        code: "IA",
        name: "Iowa",
      },
      {
        code: "KS",
        name: "Kansas",
      },
      {
        code: "KY",
        name: "Kentucky",
      },
      {
        code: "LA",
        name: "Louisiana",
      },
      {
        code: "ME",
        name: "Maine",
      },
      {
        code: "MH",
        name: "Marshall Islands",
      },
      {
        code: "MD",
        name: "Maryland",
      },
      {
        code: "MA",
        name: "Massachusetts",
      },
      {
        code: "MI",
        name: "Michigan",
      },
      {
        code: "MN",
        name: "Minnesota",
      },
      {
        code: "MS",
        name: "Mississippi",
      },
      {
        code: "MO",
        name: "Missouri",
      },
      {
        code: "MT",
        name: "Montana",
      },
      {
        code: "NE",
        name: "Nebraska",
      },
      {
        code: "NV",
        name: "Nevada",
      },
      {
        code: "NH",
        name: "New Hampshire",
      },
      {
        code: "NJ",
        name: "New Jersey",
      },
      {
        code: "NM",
        name: "New Mexico",
      },
      {
        code: "NY",
        name: "New York",
      },
      {
        code: "NC",
        name: "North Carolina",
      },
      {
        code: "ND",
        name: "North Dakota",
      },
      {
        code: "MP",
        name: "Northern Mariana Islands",
      },
      {
        code: "OH",
        name: "Ohio",
      },
      {
        code: "OK",
        name: "Oklahoma",
      },
      {
        code: "OR",
        name: "Oregon",
      },
      {
        code: "PW",
        name: "Palau",
      },
      {
        code: "PA",
        name: "Pennsylvania",
      },
      {
        code: "PR",
        name: "Puerto Rico",
      },
      {
        code: "RI",
        name: "Rhode Island",
      },
      {
        code: "SC",
        name: "South Carolina",
      },
      {
        code: "SD",
        name: "South Dakota",
      },
      {
        code: "TN",
        name: "Tennessee",
      },
      {
        code: "TX",
        name: "Texas",
      },
      {
        code: "UT",
        name: "Utah",
      },
      {
        code: "VT",
        name: "Vermont",
      },
      {
        code: "VI",
        name: "Virgin Islands",
      },
      {
        code: "VA",
        name: "Virginia",
      },
      {
        code: "WA",
        name: "Washington",
      },
      {
        code: "WV",
        name: "West Virginia",
      },
      {
        code: "WI",
        name: "Wisconsin",
      },
      {
        code: "WY",
        name: "Wyoming",
      },
    ],
  },
];
